import { render, staticRenderFns } from "./backBtn.vue?vue&type=template&id=6e0dc980&scoped=true&"
import script from "./backBtn.vue?vue&type=script&lang=js&"
export * from "./backBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0dc980",
  null
  
)

export default component.exports